<template>
    <div class="ranging">
        <div :class="idx == item.id?'btn se':'btn'"  v-for="item in menu" :key="item.id" @click="select(item)">{{item.text}}</div>
    </div>
</template>

<script>
import Draw from '../viewer/js/draw'
export default {    
    data(){
        return {
            handler:null,
            draw:new Draw(),
            pointEntyArr:[],  // 点位集合
            positionArr:[],  // 点位坐标集合
            linesArr:[], // 线段集合
            distance:0 , // 线长度 
            areaPointsArr:[],//面积点位集合
            areaPositions:[], // 面积位置集合
            areaLines:[], // 面积线集合
            areaPolygon:[], // 面积多边形
            areaPolygonPositions:[], //多边形点位数组
            polygon:null, // 画出的多边形
            menu:[
                {
                    id:1,
                    text:'测距离'
                },
                {
                    id:2,
                    text:'测面积'
                },
                {
                    id:3,
                    text:'清除'
                },
            ],
            idx:0
        }
    },
    mounted(){
        
    },
    methods:{
        initHandler(){
            let _this = this
            this.handler = new Cesium.ScreenSpaceEventHandler(viewer.scene.canvas)
            this.handler.setInputAction((moment)=>{
                
                let position = convenient._getDegreesByCartesian3(viewer.scene.pickPosition(moment.position))
                
                _this.positionArr.push(position)
                if(_this.pointEntyArr.length >= 1){
                    let line = _this.drawLine({positions:[_this.positionArr[_this.positionArr.length - 2].lon,_this.positionArr[_this.positionArr.length - 2].lat, _this.positionArr[_this.positionArr.length - 2].alt, _this.positionArr[_this.positionArr.length - 1].lon, _this.positionArr[_this.positionArr.length - 1].lat, _this.positionArr[_this.positionArr.length - 1].alt]})
                    _this.linesArr.push(line)
                    let distance = _this.getDistance(_this.positionArr[_this.positionArr.length - 2], _this.positionArr[_this.positionArr.length - 1])
                    console.log(distance);
                    _this.distance += Number(distance)
                    
                }
                
                let point = _this.drawPoint({position, text:_this.distance.toFixed(2) + 'm'})
                _this.pointEntyArr.push(point)
                

            }, Cesium.ScreenSpaceEventType.LEFT_CLICK)

            
        },
        select(item){
            this.idx = item.id
            let _this = this
            switch(item.id){
                case 1:
                    _this.start()
                    break;
                case 2:
                    _this.getArea()
                    break;
                case 3:
                    _this.remove()
                    break;
            }
        },
        start(){
            this.initHandler()
        },
        remove(){
            if(this.pointEntyArr.length >0){
                this.pointEntyArr.forEach(item =>{
                    viewer.entities.remove(item)
                })
            }
            
            if(this.linesArr.length > 0){
                this.linesArr.forEach(item =>{
                    viewer.entities.remove(item)
                })
            }
            
            if(this.areaLines.length > 0){
                this.areaLines.forEach(item =>{
                    viewer.entities.remove(item)
                })
            }

            if(this.areaPointsArr.length > 0){
                this.areaPointsArr.forEach(item =>{
                    viewer.entities.remove(item)
                })
            }

            if(this.areaPolygon.length > 0){
                this.areaPolygon.forEach(item =>{
                    viewer.entities.remove(item)
                })
            }

            this.areaPolygonPositions = []
            this.areaPositions = []
            this.distance = 0
            this.positionArr = []
            if(this.handler){
                this.handler.destroy()
                this.handler = null
            }
            
        },
        drawPoint(params){
            let point = this.draw.addPoint(params)
            return point
        },
        drawLine(params){
            let line = this.draw.addLine(params)
            return line
        },
        getDistance(start, end){
            let startp = Cesium.Cartographic.fromDegrees(start.lon, start.lat, start.alt)
            let endp = Cesium.Cartographic.fromDegrees(end.lon, end.lat, end.alt)

            let geodesic = new Cesium.EllipsoidGeodesic()
            geodesic.setEndPoints(startp, endp) 
            return geodesic.surfaceDistance 
        },
        getArea(){
            let _this = this 
            this.handler = new Cesium.ScreenSpaceEventHandler(viewer.scene.canvas)
            this.handler.setInputAction((moment)=>{
                
                //拿到点击的屏幕坐标转经纬度
                let position = convenient._getDegreesByCartesian3(viewer.scene.pickPosition(moment.position))
                _this.areaPositions.push(position)

                _this.areaPolygonPositions.push(position.lon, position.lat, position.alt)
                console.log(_this.areaPolygonPositions);

                // 在位置添加点
                let point = _this.draw.addPoint({position, labelShow:false})
                _this.areaPointsArr.push(point)

                // 画出两个点之间的线
                if(_this.areaPositions.length > 1){
                    let line = _this.draw.addLine({name:"面积线", positions:[
                        _this.areaPositions[_this.areaPositions.length - 2].lon, 
                        _this.areaPositions[_this.areaPositions.length - 2].lat,
                        _this.areaPositions[_this.areaPositions.length - 2].alt,
                        _this.areaPositions[_this.areaPositions.length - 1].lon, 
                        _this.areaPositions[_this.areaPositions.length - 1].lat,
                        _this.areaPositions[_this.areaPositions.length - 1].alt,
                    ]})
                    _this.areaLines.push(line)
                }

                

            },Cesium.ScreenSpaceEventType.LEFT_CLICK)

            // 右键结束画出面积 
            this.handler.setInputAction((moment)=>{
                // 画出面积
                if(_this.areaPositions.length > 2){
                    // 先闭合最后一条线
                    let line = _this.draw.addLine({name:"面积线", positions:[
                        _this.areaPositions[0].lon, 
                        _this.areaPositions[0].lat,
                        _this.areaPositions[0].alt,
                        _this.areaPositions[_this.areaPositions.length - 1].lon, 
                        _this.areaPositions[_this.areaPositions.length - 1].lat,
                        _this.areaPositions[_this.areaPositions.length - 1].alt,
                    ]})
                    _this.areaLines.push(line)

                    // 添加区域多边形
                    let polygon = _this.draw.addPlane({name:"面积", plane:_this.areaPolygonPositions})
                    _this.areaPolygon.push(polygon)
                    let area = _this.getPolygonArea(_this.areaPositions)
                    console.log(area);

                    let label = _this.draw.addLabel({text:Number(area).toFixed(2)  + ' 平方米', position:_this.areaPositions[0]})
                    _this.areaPointsArr.push(label)

                    _this.handler.destroy()
                    _this.handler = null
                }
            },Cesium.ScreenSpaceEventType.RIGHT_CLICK)
        },
        getPolygonArea(positions){
            let _this = this
            let area = 0

            for(let i = 0;i <positions.length - 2;i++){
                let angle = _this.getAngel(positions[i], positions[i+ 1], positions[i + 2])
                let distance1 = _this.getDistance(positions[i + 1], positions[0])
                let distance2 = _this.getDistance(positions[i + 2], positions[0])

                area += distance1 * distance2 * Math.sin(angle) / 2
            }

            return Math.abs(area)
        },
        getAngel(point1, point2, point3){
            let bearing21 = this.Bearing(point2, point1)
            let bearing23 = this.Bearing(point2, point3)
            let angle = bearing21 - bearing23
            if (angle < 0) {
                angle += Math.PI * 2.0
            }
            return angle
        },
        // 方向
        Bearing (from, to) {
            console.log(from, to);
            let fromCartographic = Cesium.Cartographic.fromDegrees(from.lon, from.lat, from.alt)
            let toCartographic = Cesium.Cartographic.fromDegrees(to.lon, to.lat, to.alt)
            let lat1 = fromCartographic.latitude
            let lon1 = fromCartographic.longitude
            let lat2 = toCartographic.latitude
            let lon2 = toCartographic.longitude
            let angle = -Math.atan2(Math.sin(lon1 - lon2) * Math.cos(lat2), Math.cos(lat1) * Math.sin(lat2) - Math.sin(lat1) * Math.cos(lat2) * Math.cos(lon1 - lon2))
            if (angle < 0) {
                angle += Math.PI * 2.0
            }
            return angle
        },
    }
}
</script>

<style lang="less" scoped>
    .ranging{
        position: fixed;
        left: 1vw;
        top: 5vh;
        width: 5vw;
        height: 15vh;
        // background: #ffffff2B;
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        .btn{
            width: 100%;
            text-align: center;
            background: #fff;
            border-radius: 5px;
            color: #000;
            font-weight: bold;
        }
        .se{
            background: #ffffff2b;
            color: #fff;
        }
    }
</style>